import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }
    
` as unknown as React.FC; // 👈 forzamos el tipo para JSX
